angular.module( 'acme.view.application.membership.rules.updowngrade', [
  'ui.router',
  'ui.bootstrap',
  'ui.scrollfix',
  'ang-drag-drop',
  'acme.view.application.membership.rules.updowngrade.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipRulesUpdowngrade = {
        name: 'application.membership.rules.updowngrade',
        url: '/updowngrade',
        views: {
          "subview-main": {
            controller: 'MembershipRulesUpdowngradeController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/rules/updowngrade/updowngrade.tpl.html'
          }
        },
        data: {
          pageTitle: 'Membership Upgrade / Downgrade',
          /** Secure With Permissions **/
          permissions: ['MEMBERSHIP_UPGRADE_DOWNGRADE_VIEW']
        }
      };

    $stateProvider
      .state(membershipRulesUpdowngrade);
});
